import { render, staticRenderFns } from "./paperTable.vue?vue&type=template&id=0cac0714"
import script from "./paperTable.vue?vue&type=script&lang=js"
export * from "./paperTable.vue?vue&type=script&lang=js"
import style0 from "./paperTable.vue?vue&type=style&index=0&id=0cac0714&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports